import {isBrower} from "./util";

import api_url from './api.config'
import {CURRENT_VERESION, UNI_VERSION} from "@/lib/version";
import {consultPublishQueryType} from "@/page/consult/lib";

export {baseParams, password} from "@/lib/baseConfig";


const client = isBrower('micromessenger') ? '微信' : isBrower('alipayclient') ? '支付宝' : '';

export const MAIN_COLOR = '#2d7eff';
export const BG_COLOR = '#F5F5F5'
export const APP_NAME = 'gjhlwyy_';
export const CACHE_PREFIX = APP_NAME + CURRENT_VERESION + "_";
export const openRealNameOauth = false;
export const API_URL = api_url;
export const ONE_DAY_TIME = 24 * 3600 * 1000;
export const relationship = ["本人", "父母", "配偶", '子女', '亲戚', '朋友', '其他']
export const relationship_en = [
  "self",
  "parents",
  "spouse",
  "children",
  "relatives",
  "friends",
  "others"]
export const BYZJ = '本院专家';

export const editForm = {
  "nethos.pat.info.modify.v2": {
    id: "patId", name: "patName", card: "patIdcard"
  },
  "nethos.pat.compat.modify.v2": {
    id: "compatId", name: "compatName", card: "compatIdcard"
  }
}


export const docNav = [{name: "book", value: "预约挂号", open: false, show: false}, {
  name: "pic", value: "图文咨询", open: false, price: ''
}, {name: "video", value: "在线视频", open: false, price: ''}, {
  name: "famous", value: "名医视频", open: false, price: ''
}, {name: "team", value: "团队咨询", open: false}]


export const couponType = {
  DISCOUNT_COUPON: '折扣券', FULL_REDUCTION_COUPON: '满减券', DIRECT_REDUCTION_COUPON: '直减券'
}

export const couponStatus = {
  UNUSED: {text: '可用', value: 0},
  USED: {text: '已使用', value: 2},
  PAST_DUE: {text: '已过期', value: 1},
  NOT_AVAILABLE: {text: '不可用', value: 3}
}

/**
 * 咨询类型
 * @type {{DOCPIC: string, VIDEO: string, PERSONAL_TIME_PIC: string, PIC: string, DOCVIDEO: string, TEAMPIC: string}}
 */
export const CONSULT_TYPE = {
  PIC: '全科咨询',
  RENEWAL_OF_CONSULTATION: '线上续方',
  DOCPIC: '图文咨询',
  VIDEO: '名医视频',
  DOCVIDEO: '视频咨询',
  TEAMPIC: '团队咨询',
  PERSONAL_TIME_PIC: "长期咨询"
}
/**
 * 咨询类型映射
 * @type {{DOCPIC, VIDEO, PERSONAL_TIME_PIC, PIC, DOCVIDEO, TEAMPIC,RENEWAL_OF_CONSULTATION}}
 */
export const CONSULT_TYPE_MAP = (data => {
  let ans = {};
  for (let dataKey in data) {
    ans[dataKey] = dataKey;
  }
  return ans;
})(CONSULT_TYPE);

export const DOWNLOAD = 'http://api.gjwlyy.com/api/download/pat/index.html';

export const MY_DOC_NAV = [{name: 'follow', value: '关注医生'}, {name: 'msg', value: '最近会话'}, {
  name: 'group', value: '我的圈子'
}, {name: 'team', value: '关注团队'}]

export const DOWNLOAD_CONTENT = client + '暂不支持该功能，请前往应用商店下载app来'

export const ORDER_STATUS = ['待支付', '已预约', '已就诊', '停诊', '未就诊', '已取消'];

export const OPEN_TEAMPIC = true;

export const OPEN_NEW_MYBOOK_VERSION = true;

export const OPEN_NEW_MYDOC_VERSION = true;

export const OPEN_MYPAY_VERSION = true;

export const OPEN_ARTICLE_DETAIL_VERSION = true;

export const NEW_PIC_CONSULT_SUBMIT = true;

export const OPEN_MYCONSULT_VERSION = true;

/**
 * 咨询订单状态
 * @type {*[]}
 */
export const CONSULT_STATUS = [
  {value: -1, name: 'CANCEL', title: '已取消'},
  {value: 0, name: 'NEEDPAY', title: '待付款'},
  {value: 2, name: 'GOING', title: '进行中'},
  {value: 4, name: 'NEEDCOMMENT', title: '待评价'},
  {value: 6, name: 'FINSH', title: '已评价'}
]

/**
 * 通用单个状态
 * */

export const CANCEL = "CANCEL";//已取消
export const GOING = 'GOING';//进行中
export const NEEDPAY = 'NEEDPAY';//待支付
export const NOPAY_CANCEL = 'NOPAY_CANCEL';//未付款取消
export const FINSH = 'FINSH'
/**
 * 号源状态
 * @type {string[]}
 */
export const SCHEME_STATUS = ["无", "停诊", "已满", "即将(未放号或号子被锁定)", "预约"] // ["0无", "1停诊", "2已满", "3即将", "4预约"]

export const trackingModuleType = {
  jybg: 'INNER_SERVER_CHECKOUT',// 检验报告
  jcbg: 'INNER_SERVER_INSPECT',// 检查报告
  tjbg: 'INNER_SERVER_HEALTHCHECK',//体检报告
  njbg: 'INNER_SERVER_IMAGE',// 内镜报告
  szyx: 'INNER_SERVER_QUERY_VIEW',// 数字影像
  pdfbg: 'INNER_SERVER_PDF_REPORT',//PDF报告
  tjyy: 'HEALTHCHECK_ORDER',//体检预约
  njzx: 'ENDOSCOPE_CENTER',//内镜中心
  rjss: 'DAY_SURGERY',//日间手术
  ibd: "IBD_CENTER",//IBD诊治中心
  kfzx: 'REHABILITATION_CENTER',//康复中心
  lbt: 'SYS_AD_SETTING',//轮播图
}

/**
 * 病理报告
 * @returns {{service: string, md: string, name: string, icon: {}, tracking: string}}
 */
const getBLBGtype = () => {
  return {
    service: 'zheer.yygh.ApiJyjcService.queryPdfRoute',
    name: '病理报告',
    icon: require('../assets/report/病理报告@2x.png'),
    md: 'INNER_SERVER_QUERY_VIEW',
    tracking: trackingModuleType.pdfbg
  }
}

/**
 * 报告类型
 * @type {*[]}
 */
export const REPORT_TYPE = [
  {
    service: 'nethos.book.inspect.list',
    name: '检验报告',
    icon: require('../assets/report/检验报告@3x.png'),
    md: 'INNER_SERVER_CHECKOUT',
    tracking: trackingModuleType.jybg
  }, {
    service: 'nethos.book.inspect.examination',
    name: '检查报告',
    icon: require('../assets/report/检查报告@3x.png'),
    md: 'INNER_SERVER_INSPECT',
    tracking: trackingModuleType.jcbg
  }, {
    service: 'zheer.yygh.ApiJyjcService.ExamList',
    name: '体检报告',
    icon: require('../assets/report/体检报告@3x.png'),
    md: 'INNER_SERVER_HEALTHCHECK',
    tracking: trackingModuleType.tjbg
  }, {
    service: 'zheer.yygh.ApiJyjcService.checkList',
    name: '内镜报告',
    icon: require('../assets/report/内镜报告@3x.png'),
    md: 'INNER_SERVER_IMAGE',
    tracking: trackingModuleType.njbg
  }, {
    service: 'nethos.book.image.imagelist',
    name: '数字影像',
    icon: require('../assets/report/影像@3x.png'),
    md: 'INNER_SERVER_QUERY_VIEW',
    tracking: trackingModuleType.szyx
  }, {
    service: 'zheer.yygh.ApiJyjcService.queryPdfRoute',
    name: 'PDF报告',
    icon: require('../assets/report/PDF报告@3x.png'),
    md: 'INNER_SERVER_QUERY_VIEW',
    tracking: trackingModuleType.pdfbg
  },
  getBLBGtype()
]

/**
 * pdf报告类型
 * @type {*[]}
 */
export const PDF_TYPE = [
  /*{
  service: 'jy',
  name: '检验PDF报告',
  icon: require('../assets/report/检验PDF报告@3x.png'),
}, {
  service: 'jc',
  name: '检查PDF报告',
  icon: require('../assets/report/检查PDF报告@3x.png'),
}, {
  service: 'tj',
  name: '体检PDF报告',
  icon: require('../assets/report/体检PDF报告@3x.png'),
}, {
  service: 'nj',
  name: '内镜PDF报告',
  icon: require('../assets/report/内镜PDF报告@3x.png'),
},*/
  {
    service: 'ECG',
    name: '心电PDF报告',
    icon: require('../assets/report/心电PDF报告@3x.png'),
  }
]

/**
 * 评价
 * @type {string[]}
 */
export const RATE = ['非常不满意', '不太满意', '一般', '比较满意', '非常满意']

/**
 * 在线医生筛选条件
 * @type {*[]}
 */
export const DOC_FILTER = [{id: 'hos', name: '全部医院', old: '全部医院'}, {
  id: 'dept',
  name: '全部科室',
  old: '全部科室'
}, {
  id: 'type', name: '全部形式', old: '全部形式'
}, {id: 'sort', name: '默认排序', old: '默认排序'},]
/**
 * 医生发布筛选条件
 * @type {*[]}
 */
export const ARTICLE_FILTER = [{id: 'dept', name: '全部科室', old: '全部科室'}, {
  id: 'sort',
  name: '最新发布',
  old: '最新发布'
},]
/**
 *
 * @type {{android: string, ios: string}}
 */
export const download = {
  android: "https://app2.z2web1.com/apk/zehys.apk",
  ios: "https://itunes.apple.com/cn/app/%E6%B5%99%E4%BA%8C%E5%A5%BD%E5%8C%BB%E7%94%9F%E6%82%A3%E8%80%85%E7%89%88/id1254433863?mt=8"
};

/**
 *
 * @type {{android: string, ios: string}}
 */
export const download_doc = {
  android: "https://app2.z2web1.com/apk/zehys_yhb.apk",
  ios: "https://itunes.apple.com/cn/app/%E6%B5%99%E4%BA%8C%E5%A5%BD%E5%8C%BB%E7%94%9F%E5%8C%BB%E6%8A%A4%E7%89%88/id1254418030?mt=8"
};
/**
 *
 * @type {*[]}
 */
export const pay_way = [{name: '支付宝', icon: '&#xe702;'}, {name: '微信', icon: '&#xe619;'}]

/**
 * 体检订单状态
 * @type {*[]}
 */
export const medical_status = [
  {name: '全部'},
  {
    name: '退款', id: 'CANCEL', alias: '已取消', notice: '退款将在7-10个工作日返回您的支付账户'
  },
  {name: '未支付取消', id: 'NO_PAY_CANCEL', alias: '已取消', notice: '超过15分钟未支付，订单自动取消'},
  {
    name: '已逾期', id: 'OVERDUE', notice: '已逾期'
  },
  {name: '待付款', id: 'WAIT_PAY', notice: '请耐心等待客服电话与您确认体检时间'},
  {
    name: '待安排', id: "WAIT_HANDLE", notice: '请耐心等待客服电话与您确认体检时间'
  },
  {name: '待服务', id: 'WAIT_CHECK', notice: '请在体检当日凭本人身份证、订单参加体检'},
  {
    name: '已到检', id: 'ALREADY_CHECK', notice: '您已完成体检，若需帮助可联系客服'
  },
  {name: '待评价', id: 'FINSH', notice: '您已完成体检，若需帮助可联系客服'},]

/**
 * 体检中心菜单
 * @type {*[]}
 */
export const medical_home_nav = [{
  name: '报告解读',
  icon: require('../assets/medical/index/报告解读@3x.png'),
  path: '/report',
  native: 'tynet://smarthos.native.report'
}, {name: '医生文章', icon: require('../assets/medical/index/医生文章@3x.png'), path: '/article'}, {
  name: '我的订单', icon: require('../assets/medical/index/我的订单@3x.png'), path: '/my/medical'
},];
/**
 * 省平台医院Id
 * @type {string}
 */
export const hosId = '095101';

/**
 * 费用查询菜单
 * @type {*[]}
 */
export const fee_nav = [{name: '门诊费用查询', id: 'mz'}, {name: '住院费用查询', id: 'zy'},]

/**
 * 婚姻状态
 * @type [0": string, "1": string, "2": string, "3": string, "4": string]
 */
export const maritalStatus = ['未婚', '已婚', '离异', '丧偶', '未知'];
/**
 * 团队默认图片
 */
export const team_default_pic = require('../assets/team.default.png');

/**
 * 首页菜单
 * @type {*[]}
 */
export const index_nav_1 = [{
  icon: require('../assets/index/去挂号@3x.png'), name: '去挂号', path: '/bookTerms'
}, {
  icon: require('../assets/index/问医生@3x.png'), name: '问医生', path: '/internetRoom', forAlipay: false
}, {
  icon: require('../assets/index/查报告@3x.png'), name: '查报告', path: '/report'
}, {
  icon: require('../assets/index/数字影像@3x.png'), name: '数字影像', forAlipay: false, path: '/report?type=数字影像'
}, {icon: require('../assets/index/更多@3x.png'), name: '更多', path: '/index/all'},];
/**
 * 首页菜单
 * @type {*[]}
 */
export const index_nav_2 = [{
  icon: require('../assets/index/nav/健康体检@3x.fw.png'),
  name: '健康体检',
  text: '套餐定制健康管理',
  path: '/medical/home',
  forAlipay: false
}, {
  icon: require('../assets/index/nav/专科护理@3x.fw.png'),
  forAlipay: false,
  name: '专科护理',
  text: '打针换药护理咨询'
}, {
  icon: require('../assets/index/nav/线上续方@3x.fw.png'), //bg: require('../assets/index/bg@3x.png'),
  name: '线上续方', text: '开药复诊药品配送', path: '/renewal', forAlipay: false
}, // {icon: require('../assets/index/nav/智慧病房@3x.png'), name: '掌上病房', text: '您的住院管家', path: '/tumour/welcome'}
  // {icon: require('../assets/index/nav/住院预缴金.png'), name: '住院预缴金', text: '手机充值便捷', path: '/butler/select'},
  {
    icon: require('../assets/index/nav/在线缴费@3x.png'),
    name: '在线缴费',
    text: '不用排队手机缴费',
    path: '/butler/pre'
  }];

/**
 * 住院状态
 * @type {string[]}
 */
export const tumour_inhospitalstatus = ['已出院', '住院中'];

/**
 * 医生开通的服务类型/咨询类型
 * @type {{DOCPIC: string, VIDEO: string, DOCVIDEO: string, RENEWAL_OF_CONSULTATION: string, TEAMPIC: string}}
 */
export const moudleType = CONSULT_TYPE;

/**
 * 医生开通的服务类型字段映射
 * @type {{VIDEO,TEAMPIC,DOCVIDEO,DOCPIC,RENEWAL_OF_CONSULTATION}}
 */
export const simpleMoudleType = ((data) => {
  let obj = {};
  for (let dataKey in data) {
    obj[dataKey] = dataKey;
  }
  return obj;
})(moudleType);


/**
 * 周
 * @type {*[]}
 */
export const weekArr = ['日', '一', '二', '三', '四', '五', '六'];
/**
 * 预约挂号类型
 * @type {*[]}
 */
export const bookType = [
  {
    name: '预约挂号', desc: '未来28天号源 在线预约'
  },
  {
    name: '当天挂号', desc: '当天号源 立挂立取', forAlipay: false
  }];

export const typeTitleMap = {
  pic: "图文咨询", renewal: "线上续方", team: "团队咨询", [consultPublishQueryType[2]]: '申请长期咨询服务'
};

/**
 * 默认公众号
 * @type {*[]}
 */
export const default_appid = ['wxa49f90b4ff678ef2', 'wxdc0239e58f68557e', 'wx3d274480f31f6de2'];


export const PAY_WAY = [
  {name: '微信', value: '', brower: 'weixin', icon: '&#xe619;'},
  {name: '支付宝', value: '', brower: 'alipay', icon: '&#xe702;'}
];

/**
 * 当日挂号支付方式
 */
export const TODAY_PAY_WAY = [
  {name: '医院自助机（到院医保取号）', icon: require('../assets/icon/医保挂账icon@2x.png'), type: '3'},
  {name: '微信（自费支付）', icon: require('../assets/icon/微信支付@2x.png'), type: '2'}
];

/**
 * 系统参数
 * @type {{}}
 */
export const XTCS = {
  "EXAM_TEAM": "EXAM_TEAM",// 体检咨询 团队id
  "DOCTORS_DAY_DOCTORS_AWARDS_1": "DOCTORS_DAY_DOCTORS_AWARDS_1",//年度荣耀医者奖
  "DOCTORS_DAY_TEAM_AWARDS": "DOCTORS_DAY_TEAM_AWARDS",//疫情义诊仁心团队奖
  "DOCTORS_DAY_DOCTORS_AWARDS_2": "DOCTORS_DAY_DOCTORS_AWARDS_2",//药事服务仁心医者
  "DOCTORS_DAY_CONTRIBUTION_TEAM": "DOCTORS_DAY_CONTRIBUTION_TEAM",//药事服务突出贡献团队
  "SELF_PAY_STATUS": "SELF_PAY_STATUS",// 门诊支付开关
  "RECHARGE_PAY_STATUS": "RECHARGE_PAY_STATUS",//住院支付开关
  "ORDER_BOOK_REMIND": "ORDER_BOOK_REMIND",//预约挂号提醒（/book/dept）
  "FREE_CLINIC_ACTIVITY_WEEK": "FREE_CLINIC_ACTIVITY_WEEK",
  "FREE_CLINIC_SWITCH_STATUS": "FREE_CLINIC_SWITCH_STATUS",
  "2022_FREE_CLINIC_ANNIVERSARIES": "2022_FREE_CLINIC_ANNIVERSARIES",
  "WARD_DESCRIPTION_STATUS": "WARD_DESCRIPTION_STATUS",// 病情描述
  "EPIDEMIC_PREVENTION_AND_CONTROL_STATUS": "EPIDEMIC_PREVENTION_AND_CONTROL_STATUS",//前端住院疫情防控问卷功能开放状态
  "IS_OPEN_XSXF": "CONTINUATION_STATE",//是否开通线上续方
  "DAY_SURGER_TEAM_ID": "DAY_SURGER_TEAM_ID",
  "DAY_SURGERY_SWITCH": "DAY_SURGERY_SWITCH",// 是否开通日间手术进度查询
  "SCHOOL_HOS_AVATAR": "SCHOOL_HOS_AVATAR",// 校医院缩略图
  "SCHOOL_HOS_ADDRESS": "SCHOOL_HOS_ADDRESS",// 校医院地址
  "SCHOOL_HOS_LIST_OBJ": "SCHOOL_HOS_LIST_OBJ",// 校医院
  "INSURANCE_CONFIG": "INSURANCE_CONFIG",// 我要投保是否开启
  "INSURANCE_CONFIG_MOBILE": "INSURANCE_CONFIG_MOBILE",// 投保电话
  "ESCORT_APPLICATION": "ESCORT_APPLICATION",//陪护申请
  "ESCORT_CERTIFICATE": "ESCORT_CERTIFICATE",//陪护证
  "2022_FREE_CLINIC_ANNIVERSARIES_BA": "2022_FREE_CLINIC_ANNIVERSARIES_BA",//博奥义诊活动
  "FREE_ACTIVITY_SETTING": "FREE_ACTIVITY_SETTING",// 义诊是否开启
  "DAY_CHEMO_CONFIGURATION": "DAY_CHEMO_CONFIGURATION",// 日間化療
  "FREE_FEVER_DEPT_LIST": "FREE_FEVER_DEPT_ID_LIST",//义诊发热咨询科室列表
  "FREE_NURSING_DEPT_ID_LIST": "FREE_NURSING_DEPT_ID_LIST",// 义诊护士主题科室ID列表：
  "FREE_PLAT_TEAM_ID_LIST": "FREE_PLAT_TEAM_ID_LIST",//义诊引导团队id列表
  "FREE_OLDAGE_DEPT_ID_LIST": "FREE_OLDAGE_DEPT_ID_LIST",//老年专窗,
  "FREE_CLINIC_FREE_SWITCH_STATUS": "FREE_CLINIC_FREE_SWITCH_STATUS",// 首页发热义诊,
  "MANBING_STATE": "MANBING_STATE",// 就医服务-慢病按钮开启状态,
  "ASIAN_GAME_ESCORT_ZONE_STATUS": "ASIAN_GAME_ESCORT_ZONE_STATUS",// 首页亚运专窗
  "HOSPITALIZATION_BUSINESS_POPUP_OPEN": "HOSPITALIZATION_BUSINESS_POPUP_OPEN",//住院查询业务（入院服务、日间手术）前端页面halo升级弹窗开启状态
}

/**
 * 住院管家，在院状态
 * @type {{"0": string, "1": string}}
 */
export const BUTLER_ZYZT = {
  0: '出院', 1: '在院'
}

/**
 * 问医生查询条件缓存
 * @type {string}
 */
export const find_doc_form_cache_key = 'find_doc_form_cache_key';

/**
 * 在线缴费类型
 * @type {({label: string, value: string, desc: string}|{label: string, value: string, desc: string})[]}
 */
export const butler_type = [{
  label: '门诊缴费',
  value: 'mz',
  desc: '手机支付门诊费用，节省排队时间',
  icon: require('../assets/butler/门诊缴费@3x.png')
}, {
  label: '住院缴费',
  value: 'zy',
  desc: '住院预缴金在线支付，查询住院清单',
  icon: require('../assets/butler/住院缴费@3x.png')
}]

/**
 * 病情描述缓存
 * @type {string}
 */
export const illness_form_cache_key = 'illness_form_cache_key'
/**
 * 病情描述
 * @type {({label: string, id: string}|{label: string, id: string}|{label: string, id: string}|{label: string, id: string})[]}
 */
export const illness_form = [{
  label: '过敏史', id: 'guominshi'
}, {
  label: '疾病史', id: 'suohuanjibing'
}, {
  label: '手术史', id: 'shoushushi'
}, {
  label: '外伤史', id: 'waishangshi'
}, {
  label: '其他', id: 'qita'
}, {
  label: '婚育史', id: 'hunyushi'
}, {
  label: '月经史', id: 'yuejingshi'
}, {
  label: '家族史', id: 'jiazushi'
},

]
/**
 * 咨询形式
 * @type {({name: string, id: string}|{name: string, id: string}|{name: string, id: string}|{name: string, id: string}|{name: string, id: string, desc: string})[]}
 */
export const consult_type = [{id: '', name: '全部形式'}, //{id: 'docFamousConsultStatus', name: '名医视频'},
  {id: 'docPicConsultStatus', name: '图文咨询'}, {id: 'docVideoConsultStatus', name: '视频咨询'}, {
    id: 'teamConsultStatus', name: '团队咨询', desc: '回复快'
  }, {id: 'prescriptionStatus', name: '可开处方', desc: '药品送到家'},]

/**
 * 咨询排序
 * @type {({name: string, id: string}|{name: string, id: string}|{name: string, id: string}|{name: string, id: string}|{name: string, id: string})[]}
 */
export const consult_sort = [{id: '', name: '默认排序'}, {id: 'docScoure', name: '按好评排序'}, {
  id: 'consultCount', name: '按服务次数排序'
}, // {id: 'serviceNumber', name: '按开通服务数排序'},
  // {id: 'famousSort', name: '名医排序'},
  // {id: 'recommendSort', name: '推荐排序'}
]

/**
 * 住院问卷类型
 * @type {string}
 */
export const ZYWJ = 'HOSPITALIZATION_SATISFACTION'

/**
 * 一天的毫秒数
 * @type {number}
 */
export const DAY_DELTA = 24 * 3600 * 1000;

/**
 * 医生类型
 * @type {{DOC: string, NURSE: string}}
 */
export const doc_type = {
  DOC: '医生', NURSE: '护士'
}

/**
 * 医生类型简单映射
 * @type {{NURSE,DOC,PHAR}}
 */
export const simple_doc_type = (types => {
  let obj = {};
  for (let key in types) {
    obj[key] = key;
  }
  obj.PHAR = "PHAR";// 药师
  return obj;
})(doc_type)


/**
 * 专栏代码
 * @type {{RARE_DISEASE: string, NURSING_COLUMN: string}}
 */
export const SPECIALCODE = {
  NURSING_COLUMN: '护理专栏', RARE_DISEASE: '罕见病'
}

/**
 * @typedef {Object} SPECIALCODE_MAP
 * @property {string} RARE_DISEASE  罕见病
 * @property {string} NURSING_COLUMN  护理专栏
 */
export const SPECIALCODE_MAP = (types => {
  let obj = {};
  for (let key in types) {
    obj[key] = key;
  }
  return obj;
})(SPECIALCODE)


/**
 * 问卷类型
 * @type {{HEALTHCHECK_QUESTIONNAIRE: string,HEALTHCHECK_QUESTIONNAIRE:string}}
 */
export const typeList = {
  HOSPITALIZATION_SATISFACTION: "HOSPITALIZATION_SATISFACTION",//住院
  HEALTHCHECK_QUESTIONNAIRE: 'HEALTHCHECK_QUESTIONNAIRE'//体检
}

/**
 * 用户类型
 * @type {{PAT: string, DOC: string}}
 */
export const USER_TYPE = {
  "PAT": "患者", "DOC": "医生"
}

/**
 * 专属二维码状态
 * @type {{CODECLOSE: string, CONSULTCLOSE: string, UNUSED: string, USED: string}}
 */
export const EXCLUSIVE_CODE_STATE = {
  UNUSED: '未用', USED: '已用', CODECLOSE: '码关闭', CONSULTCLOSE: '咨询关闭'
}
/**
 * 专属二维码
 * @type {{"UNUSED":"UNUSED","USED":"USED","CODECLOSE":"CODECLOSE","CONSULTCLOSE":"CONSULTCLOSE"}}
 */
export const EXCLUSIVE_CODE_STATE_MAP = (data => {
  let obj = {}
  for (let k in data) {
    obj[k] = k;
  }
  Log('@type', JSON.stringify(obj));
  return obj;
})(EXCLUSIVE_CODE_STATE);

/**
 * 上传类型
 * @type {{image: string, video: string}}
 */
export const ACCEPT_TYPE = {
  video: 'video/*',
  image: 'image/*'
}

/**
 * 诊间支付结算id
 * @type {string}
 */
export const JIESUAN_ID = '47874602';

/**
 * 滨江 bookHosId
 * @type {number}
 */
export const BINJIANG_BOOKHOSID = 8

/**
 * 门诊满意度需要特殊处理的问卷
 * @type {string}
 */
export const teshudewenjuan1 = '互联网医院满意度调查问卷';


/**
 * 挂号类型
 * @type {string[]}
 */
export const yyghType = ['预约挂号', '当天挂号', '校医院'];

/**
 * 预约挂号退号提示文案
 * @type {string}
 */
export const yyghBookOrderCancelText = '频繁退号可能被加入黑名单，导致无法使用预约挂号功能。规则详见预约挂号须知';

/**
 * 非常用设备
 * @type {string}
 */
export const FEICHANGYONGSHEBEI_CODE = '01020805'

export const NEED_REGISTER_CODE = '01020804';


/**
 * token失效的code
 * @type {string[]}
 */
export const NO_LOGIN_CODE = ['00000009', '00000010'];

/**
 * 常见图标
 * @type {{file: *}}
 */
export const ICONS = {
  file: require('@/assets/icon/文件图标@2x.png')
}

/**
 * 日期格式化
 * @type {string}
 */
export const Y_M_D = '%Y-%m-%d';
export const Y_M_D_Hms = '%Y-%m-%d %H:%M:%S';
export const Dayjs_Y_M_D = 'YYYY-MM-DD'
export const Dayjs_Y_M_D_Hms = 'YYYY-MM-DD HH:mm:ss'
/**
 * 临时保存登录用的手机号
 * @type {string}
 */
export const LOGIN_MOBILE_CACHE_KEY = 'LOGIN_MOBILE_CACHE';

/**
 * 跳转药事服务公共参数
 * @type {{mode: string, source: string}}
 */
export const REMEWAL_PUBLIC_QUERY = {
  mode: 'token',
  source: 'tyPublic',
}

export const CURR_COMPAT_INDEX = 'currCompatIndex'

/**
 * 国际医学部预约订单
 * @type {string}
 */
export const GJYXB_FORM = 'gjyxb_form';
/**
 * 挂号类型为 Halo
 * @type {string}
 */
export const HALO = 'halo';



// WEBPACK FOOTER //
// ./src/lib/config.js